// Copias de seguridad al NAS: lo que informa el contenedor de copias (deploy/backup).
import { useEffect, useState } from 'react';
import { CheckCircle2, CircleHelp, TriangleAlert, XCircle } from 'lucide-react';
import { api, type BackupJob, type Status } from '../../api.ts';
import { t } from '../../i18n/index.ts';
import { errorText, useApp } from '../../store.ts';
import { ago, bytes, fullDate } from '../../format.ts';

function JobRow({ name, hint, job, extra }: { name: string; hint: string; job: BackupJob; extra?: string }) {
  const icon =
    job.ok === true ? <CheckCircle2 size={14} color="var(--ok)" /> : job.ok === false ? <XCircle size={14} color="var(--danger)" /> : <CircleHelp size={14} color="var(--icon)" />;
  return (
    <div className="list-row">
      {icon}
      <div className="col grow" style={{ gap: 4 }}>
        <span>{name}</span>
        <span className="hint ellipsis" title={job.detail ?? hint}>
          {job.ok === false && job.detail ? job.detail : hint}
        </span>
      </div>
      {extra ? <span className="muted">{extra}</span> : null}
      <span className="hint" title={fullDate(job.at)}>
        {ago(job.at)}
      </span>
    </div>
  );
}

export function Backups() {
  const notify = useApp((s) => s.notify);
  const [b, setB] = useState<Status['backups'] | null>(null);
  useEffect(() => {
    api
      .status()
      .then((s) => setB(s.backups))
      .catch((e) => notify(errorText(e), true));
  }, [notify]);
  if (!b) return null;
  const overall = {
    ok: <span className="badge green">{t('backups.ok')}</span>,
    late: <span className="badge amber">{t('backups.late')}</span>,
    error: <span className="badge red">{t('backups.error')}</span>,
    unknown: <span className="badge">{t('backups.unknown')}</span>,
  }[b.overall];
  return (
    <section className="section">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h2>{t('ws.backups')}</h2>
        {overall}
      </div>
      <p className="hint">{t('backups.hint')}</p>
      {b.overall === 'unknown' ? (
        <div className="panel row">
          <TriangleAlert size={14} color="var(--warn)" />
          <span className="hint">{t('backups.notConfigured')}</span>
        </div>
      ) : null}
      <div className="list">
        <JobRow name={t('backups.litestream')} hint={t('backups.litestreamHint')} job={b.litestream} />
        <JobRow name={t('backups.restic')} hint={t('backups.resticHint')} job={b.restic} {...(b.restic.sizeBytes ? { extra: bytes(b.restic.sizeBytes) } : {})} />
        <JobRow name={t('backups.check')} hint={t('backups.checkHint')} job={b.check} />
        <JobRow name={t('backups.drill')} hint={t('backups.drillHint')} job={b.drill} />
      </div>
    </section>
  );
}
